// extracted by mini-css-extract-plugin
module.exports = {"container":"_1_lVP","content":"_2LdeX","left-top":"_1FNtK","right-top":"_2uFSC","left-bottom":"_3A_Un","right-bottom":"GtEVd"};